module.exports = "<div class=\"action-buttons\">\n\t<a ng-click=\"$ctrl.onEdit(element)\"\n\t\tclass=\"button edit-button\">\n\t\t<i class=\"icon-edit-pen\"></i>\n\t</a>\n\t<a ng-click=\"$ctrl.onDelete(element)\"\n\t   class=\"button delete-button\">\n\t\t<i class=\"icon icon-clear\"></i>\n\t</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/directives/jf-action-buttons/action.buttons.view.html
// module id = 491
// module chunks = 7